import { ReactNode } from 'react';
import { FieldErrors } from 'react-hook-form';
import styled, { css } from 'styled-components';

import { ApiStatuses } from 'coreOld/enums';

import Icon from './Icon';
import LoaderSpinner from './LoaderSpinner';

const iconStyle = {
  fontSize: 'inherit',
  marginRight: 4,
  color: 'inherit',
};

const spinnerStyle = {
  width: 14,
  height: 14,
};

export const NOTIFICATION_ICON = {
  [ApiStatuses.SUCCESS]: <Icon name={Icon.SUCCESS} style={iconStyle} />,
  [ApiStatuses.ERROR]: <Icon name={Icon.EXCLAMATION} style={iconStyle} />,
  [ApiStatuses.LOADING]: <LoaderSpinner style={spinnerStyle} />,
  [ApiStatuses.INFO]: <Icon name={Icon.INFO} style={iconStyle} />,
  [ApiStatuses.WARNING]: <Icon name={Icon.INFO} style={iconStyle} />,
};

type NotificationWrapperProps = {
  showNotification?: boolean;
  type?: ApiStatuses;
  children?: ReactNode;
};

export const NotificationWrapper = styled.div<NotificationWrapperProps>`
  font-size: 12px;
  margin: 10px 0 3px;
  padding: 10px;
  background-color: ${({ theme }) => theme.palette.error};
  display: flex;
  align-items: center;
  transition: all 1s;
  opacity: ${({ showNotification }) => (showNotification ? '90%' : '0')};
  display: ${({ showNotification }) => !showNotification && 'none'};

  ${({ type }) => {
    switch (type) {
      case ApiStatuses.SUCCESS:
        return css`
          background-color: ${({ theme }) => theme.palette.success};
        `;
      case ApiStatuses.ERROR:
        return css`
          background-color: ${({ theme }) => theme.palette.error};
        `;
      case ApiStatuses.LOADING:
        return css`
          background-color: ${({ theme }) => theme.palette.loading};
        `;
      case ApiStatuses.INFO:
        return css`
          background-color: ${({ theme }) => theme.palette.loading};
        `;
      case ApiStatuses.WARNING:
        return css`
          background-color: ${({ theme }) => theme.palette.warning};
        `;
      default:
        return css``;
    }
  }}
`;

interface NotificationMessageWrapperProps {
  children?: ReactNode;
}

export const NotificationMessageWrapper = styled.span<NotificationMessageWrapperProps>``;

interface IProps {
  type: ApiStatuses;
  message?: string | FieldErrors | JSX.Element;
  showNotification: boolean;
}

/** @deprecated */
const Notification = ({ type, message, showNotification }: IProps) => {
  const NotificationIcon = NOTIFICATION_ICON[type];

  return (
    <NotificationWrapper type={type} showNotification={showNotification}>
      {NotificationIcon}
      <NotificationMessageWrapper>{message as any}</NotificationMessageWrapper>
    </NotificationWrapper>
  );
};

export default Notification;
